import PageShell from '@/pages/shared/PageShell';

export default function Privacy() {
  return (
    <PageShell
      title="プライバシーポリシー｜”おもいむすび”"
      description="”おもいむすび”のプライバシーポリシー。個人情報の取り扱いについて定めています。"
      canonical="https://omoimusubi.asia/privacy/"
      h1="プライバシーポリシー"
      showCTA={false}
      relatedLinks={[
        { label: '利用規約', path: '/terms/' },
        { label: '特定商取引法に基づく表記', path: '/commercial-law/' },
      ]}
    >
      <section>
        <h2>個人情報の収集について</h2>
        <p>当社は、本サービスの提供にあたり、以下の情報を収集することがあります。</p>
        <ul>
          <li>会社名、部署名、役職</li>
          <li>氏名、メールアドレス、電話番号</li>
          <li>本サービスの利用履歴</li>
          <li>お問い合わせ内容</li>
        </ul>
      </section>
      <section>
        <h2>個人情報の利用目的</h2>
        <p>収集した個人情報は、以下の目的で利用します。</p>
        <ul>
          <li>本サービスの提供・運営</li>
          <li>利用者からのお問い合わせへの対応</li>
          <li>本サービスに関する情報のご案内</li>
          <li>本サービスの改善・開発</li>
        </ul>
      </section>
      <section>
        <h2>個人情報の第三者提供</h2>
        <p>当社は、法令に基づく場合を除き、利用者の同意なく個人情報を第三者に提供することはありません。</p>
      </section>
      <p className="text-sm text-foreground-500 mt-10">※ 本プライバシーポリシーは仮のものです。正式なサービス提供時には、弁護士監修のもと適切な内容に更新されます。</p>
    </PageShell>
  );
}